import React from 'react';
import { useTranslation } from 'react-i18next';
import { BasicTable } from './BasicTable/BasicTable';
import { BaseButton } from '../common/BaseButton/BaseButton';
import {  useNavigate } from "react-router-dom";

const CategoriesList: React.FC = () => {
    const { t } = useTranslation();
    let navigate = useNavigate();
    return (
        <>
            <div style={{ marginBottom: '20px',flexDirection:'row',display:'flex',justifyContent: 'space-between' }}>
                <h4 style={{fontWeight:'bold'}}>Manage Products</h4>
                <BaseButton type="primary" onClick={()=>navigate('/admin/products/add')}>Add New</BaseButton>
            </div>

            <BasicTable />
        </>
    );
};

export default CategoriesList;
